module.exports = __webpack_public_path__ + "img/logo.1320bc14.png";